import { gql } from '@apollo/client';

export const GET_MATCH_WEEK_TOP_PLAYERS = gql`
  query GetMatchWeekTopPlayers($matchWeekId: ID!) {
    matchWeekTopPlayers(matchWeekId: $matchWeekId) {
      matchWeek {
        id
        weekNumber
      }
      players {
        fantasyScore
        player {
          id
          nick
          name
          lastName
          role
          marketValue
          image
          totalScore
          team {
            id
            nameShow
            shortName
            shield
            shieldPng
          }
        }
      }
    }
  }
`;
